// #175 — which code a deployed instance runs, readable by anyone: OVO prod, dev
// and the dedicated instances (CT) are built from the same repo, and the label
// shows that they match. Injected by the `build` npm scripts (git commit + UTC
// date); "local" under `npm start`.
export const buildSha = process.env.REACT_APP_BUILD_SHA || 'local';
export const buildDate = process.env.REACT_APP_BUILD_DATE || '';
export const buildLabel = buildDate ? `${buildSha} · ${buildDate}` : buildSha;
